import { hyperdbHandlers } from 'hyperdb-utils';

export default hyperdbHandlers({ namespace: 'COUNTRY' });



// WEBPACK FOOTER //
// ./src/frontend/modules/address-book/country/handlers.js